import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./css/style.css";
import { useDispatch, useSelector } from "react-redux";
import { setVisitorID, setVisitorProfile } from "../../Store/actions/profile/profileReducer";
import { findDisplayName, formatNumberWithMask } from "../../../utils/commonFunctionsAndStatices";
import { setOrganization } from "../../Store/actions/getorganization/organizationSelector";

const CheckoutTable = (props) => {
  const organization = useSelector(setOrganization);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSubmit = (id) => {
    dispatch(setVisitorID(id));
    navigate("/ProfileScreen");
  };

  const formatDateTime = (timestamp) => {
    if (timestamp === "null") {
      return "";
    } else {
      const date = new Date(timestamp);
      const options = { timeZone: "UTC" };
      return date.toLocaleString("en-US", options);
    }
  };

  let data = props.data;
  if (!data || data?.length === 0) {
    return null; // Don't render anything if there's no data
  }

  var dataCopy = data.slice().sort((a, b) => new Date(b.checkin) - new Date(a.checkin));

  function findVisitorTypeById(id) {
    var root = JSON.parse(sessionStorage.getItem("persist:root"));
    var visitorTypeList = JSON.parse(root.visitorTypeTable).visitortable;
    if (visitorTypeList) {
      const foundItem = visitorTypeList?.find((item) => item.visitortypeid === id);
      return foundItem ? foundItem.name : null;
    } else if (!visitorTypeList) {
      var visitorType = JSON.parse(root.visitorType).visitorArr;
      const foundItem = visitorType?.find((item) => item.visitortypeid === id);
      return foundItem ? foundItem.name : null;
    }
  }

  return (
    <div className="container">
      <div className="row pt-4">
        <div className="p-2">
          <div className="table-wrapper">
            <table className="checkouttable">
              <thead>
                <tr >
                  <th scope="col" className="ps-4" >{findDisplayName("checkOutPageBadgeHeading", "Badge")}</th>
                  <th scope="col" >{findDisplayName("checkOutPageNameHeading", "Name")}</th>
                  <th scope="col" >{findDisplayName("checkOutPageVisitorTypeHeading", "Visitor Type")}</th>
                  <th scope="col" >{findDisplayName("checkOutPageCheckinHeading", "Check-in")}</th>
                  <th scope="col" className="ps-4">{findDisplayName("checkOutPageActionHeading", "Action")}</th>
                </tr>
              </thead>
              <tbody>
                {dataCopy?.map((item, index) => (
                  <tr key={index}>
                    <td className="ps-3"> {formatNumberWithMask(item.badge_number, organization.badge_number_mask)}</td>
                    <td className="ps-2">{item.name}</td>
                    <td className="ps-2">{findVisitorTypeById(item.visitor_type_id)}</td>
                    <td className="ps-2">
                      {item.checkin
                        ? formatDateTime(item?.checkin)
                        : ""}
                    </td>
                    <td>
                      <button
                        className="checkoutbutton "
                        onClick={() => handleSubmit(item.visitor_id)}
                      >
                        <span className="">{findDisplayName("checkOutPageCheckOutButton", "Check Out")}</span>
                        <svg
                          className="ms-1"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.16675 10H15.0001M10.8334 5L15.2442 9.41074C15.5696 9.73618 15.5696 10.2638 15.2442 10.5893L10.8334 15"
                            stroke="white"
                            strokeWidth="1.67"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutTable;
